import * as action from '../features/side-bar/SideBar.actions';

export const setFullscreen = (dispatch, args = true) => {
  if (!dispatch) return false;
  let hideSidebar = false;
  let hideHeader = false;
  if (typeof args === 'boolean') {
    hideSidebar = args;
    hideHeader = args;
  } else {
    const { hideSidebar: hs = hideSidebar, hideHeader: hh = hideHeader } = args;
    hideSidebar = hs;
    hideHeader = hh;
  }
  dispatch(action.toggleFullscreenAction({ hideSidebar, hideHeader }));
  return true;
};

/**
 * Expose methods whcih can be called by micro apps.
 */
const MfaCommunicator = (props) => {
  const Logger = (() => {
    // set logger to Rollbar
    const logger = window.Rollbar || null;
    return {
      critical: (message, data) => { if (logger) logger.critical(message, data); },
      error: (message, data) => { if (logger) logger.error(message, data); },
      info: (message, data) => { if (logger) logger.info(message, data); },
      log: (message, data) => { if (logger) logger.log(message, data); },
      warning: (message, data) => { if (logger) logger.warning(message, data); },
      debug: (message, data) => { if (logger) logger.debug(message, data); },
    };
  })();

  // toggle sidebar methods
  const Sidebar = (() => {
    if (props && props.store && props.store.dispatch) {
      const { dispatch } = props.store;
      return {
        toggleSidebarShow: () => setFullscreen(dispatch, false),
        toggleSidebarHide: () => setFullscreen(dispatch, true),
      };
    }
    return {};
  })();

  // fullscreen
  const SetFullscreen = (() => {
    if (props && props.store && props.store.dispatch) {
      const { dispatch } = props.store;
      return {
        setFullscreen: (args) => setFullscreen(dispatch, args),
      };
    }
    return {};
  })();

  window.ev_vp = {
    ...window.ev_vp,
    Logger,
    ...Sidebar,
    ...SetFullscreen,
  };
};

export default MfaCommunicator;
